import React from "react";
import { PageContent } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import DocumentAuditTrail from "features/DocumentAuditTrail/DocumentAuditTrail";

const DocumentAuditTrailPage = () => {
  const { t } = useTranslation("documentAuditTrails");

  return (
    <PageContent className="data-uploads">
      <h4 className="settings-header">{t("header")}</h4>

      <div className="content-container principal-list users-list">
        <DocumentAuditTrail />
      </div>
    </PageContent>
  );
};

export default DocumentAuditTrailPage;
